var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelsPlansPrimaryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.528,
    height: 15.032,
    viewBox: "0 0 13.528 15.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161028",
    "data-name": "Group 161028",
    transform: "translate(-19.25 -363.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bill-dollar-svgrepo-com",
    transform: "translate(16 361.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M16,11.511h1.879a1.128,1.128,0,0,0,1.128-1.128h0a1.128,1.128,0,0,0-1.128-1.128h-.752A1.128,1.128,0,0,1,16,8.128h0A1.128,1.128,0,0,1,17.128,7h1.879",
    transform: "translate(-2.979 -0.993)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-2",
    "data-name": "secondary",
    d: "M15.518,6.752V6m0,6.014v-.752m-4.511,1.5H8m3.007-3.007H8",
    transform: "translate(-0.993 -0.745)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M11.518,3H4.752A.752.752,0,0,0,4,3.752v12.78l1.759-.752,1.752.752,1.752-.752,1.752.752,1.752-.752,1.759.752V14.277",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsPlansPrimaryIcon);
export default __webpack_public_path__ + "static/media/channels-plans--primary-icon.d20cb00697c3753e6a1bf619f25ac40a.svg";
export { ForwardRef as ReactComponent };